export enum RenderingActionTypes {
  SET_CAMERA_POS = 'SET_CAMERA_POS',
}
